/**
 * Replace HTML special characters with their corresponding entities, to
 * prevent XSS attacks when passing unknown strings to v-html.
 */
const escapeHTML = unsafeString => unsafeString.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');

export { escapeHTML };
